import { hasPermission, PermissionAction } from "utils/permissions";
import { useAppSelector } from "./useAppSelector";

const usePermissions = () => {
    const { data } = useAppSelector(({ user }) => user);

    const can = (resource: string, action: PermissionAction) => hasPermission(data.permissions, resource, action);

    return { can, permissions: data.permissions };
};

export default usePermissions;
